// src/pages/qc/FgNcCreateModal.jsx
import { useState } from "react";
import { todayDubai } from "../../utils/dateUtils";

const TODAY = todayDubai();

const DISPOSITION_OPTIONS = [
  { value: "APPROVE",               label: "Approve" },
  { value: "APPROVE_CONDITIONALLY", label: "Approve Conditionally" },
  { value: "REWORK",                label: "Rework" },
  { value: "REJECT_RECYCLE",        label: "Reject and Recycle" },
  { value: "DESTROY",               label: "Destroy" },
];

export function FgNcCreateModal({ onSave, onCancel }) {
  const [form, setForm] = useState({
    productName:     "",
    batchNumber:     "",
    productionDate:  "",
    testDate:        TODAY,
    reportedBy:      "",
    dueDate:         "",
    findings:        "",
    immediateCauses: "",
    disposition:     "",
  });
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState(null);

  function set(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const body = {
        ...form,
        productionDate: form.productionDate || null,
        dueDate:        form.dueDate        || null,
        disposition:    form.disposition    || null,
      };
      await onSave(body);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  }

  return (
    <div className="modal" style={{ width: 580 }}>
      <div className="modal-header">
        <div className="modal-title">New Non-Conformance Report — Finished Goods</div>
        <button className="modal-close" onClick={onCancel}>✕</button>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div style={{ fontWeight: 600, fontSize: 12, color: "#1a3a6b",
            borderBottom: "2px solid #1a3a6b", marginBottom: 12, paddingBottom: 4 }}>
            Part 1 — Non-Conformance Details (QC)
          </div>

          <div className="form-row">
            <div className="form-group" style={{ flex: 2 }}>
              <label className="form-label">Product Name *</label>
              <input className="form-input" required value={form.productName}
                onChange={e => set("productName", e.target.value)} />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Batch Number</label>
              <input className="form-input" value={form.batchNumber}
                onChange={e => set("batchNumber", e.target.value)} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Production Date</label>
              <input className="form-input" type="date" value={form.productionDate}
                onChange={e => set("productionDate", e.target.value)} />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Test Date *</label>
              <input className="form-input" type="date" required value={form.testDate}
                onChange={e => set("testDate", e.target.value)} />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Reported By *</label>
              <input className="form-input" required value={form.reportedBy}
                onChange={e => set("reportedBy", e.target.value)} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Due Date</label>
            <input className="form-input" type="date" value={form.dueDate}
              onChange={e => set("dueDate", e.target.value)} style={{ width: 180 }} />
          </div>

          <div className="form-group">
            <label className="form-label">Findings *</label>
            <textarea className="form-input" rows={6} required value={form.findings}
              onChange={e => set("findings", e.target.value)}
              placeholder="Describe the non-conformance in detail…" />
          </div>

          <div className="form-group">
            <label className="form-label">Immediate Causes</label>
            <textarea className="form-input" rows={4} value={form.immediateCauses}
              onChange={e => set("immediateCauses", e.target.value)}
              placeholder="Immediate causes identified by QC…" />
          </div>

          <div className="form-group">
            <label className="form-label">Immediate Action</label>
            <select className="form-select" value={form.disposition}
              onChange={e => set("disposition", e.target.value)}>
              <option value="">— Select —</option>
              {DISPOSITION_OPTIONS.map(o => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>

          {error && <div className="alert-warn" style={{ marginTop: 8 }}>{error}</div>}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "Creating…" : "Create NC Report"}
          </button>
        </div>
      </form>
    </div>
  );
}
